// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"06c55bdf","23":"9d6cb910","353":"8b5051cd","415":"3f9a0164","571":"59f1c964","614":"a2704ebf","731":"073b2a03","809":"fb9e8b8e","818":"0f7aab71","866":"092ce2a1","885":"05f09490","982":"78b8e391","994":"41f8f989"}[chunkId] + ".chunk.js";
};